import PageLayout from 'components/PageLayout';

// const testValue = `
//   <p>hello 1 this is line one 11.</p>
//   <p>hello 2 this is line two 22.</p>
//   <p>hello 3 this is line three 33.</p>
//   <p>hello 4 this is line three 44.</p>
//   <p>hello 5 this is line three 55.</p>
//   <p>hello 6 this is line three 66.</p>
// `;

const Main = () => {
  return (
    <PageLayout />
  );
}

export default Main;